import styled from 'styled-components';

export const Container = styled.div``;

export const SwitchContainer = styled.div`
  display: flex;
  flex-direction: row
  align-items: center;
  margin-top: 2vh;
  margin-bottom: 15px;
`;

export const BottomContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;
